import { Component, OnInit } from '@angular/core';
import { KitProcessingService } from '../services/kit-processing.service';
import { NfrpAlertMessage } from 'nfrp-shared-angular';

@Component({
    selector: 'app-track-ssnc',
    templateUrl: './track-ssnc.component.html',
    styleUrls: ['./track-ssnc.component.css'],
    standalone: false
})
export class TrackSsncComponent implements OnInit {
  processingKitData: any;
  kitData: any;
  plansMissingZipFile: string;
  private subscriptions = [];
  planIDCleanUp: string;
  planIdForEnrollment: string;
  successMessage: NfrpAlertMessage;
  errorMessage: NfrpAlertMessage;
  constructor(private kitProcessingService:KitProcessingService) {}

  ngOnInit() {
    this.kitStatus();
    this.zipStatus();
  }

  kitStatus(): void {
    this.subscriptions.push(
      this.kitProcessingService.kitStatus().subscribe((data) => {
        this.processingKitData = data;
      },
      (error) => {
        window.scroll(0, 0);
        this.errorMessage = { message: error, details: [] };
      })
    );
  }

  zipStatus(): void {
    this.subscriptions.push(
      this.kitProcessingService.zipStatus().subscribe((data) => {
        this.kitData = data;
        this.plansMissingZipFile =  this.kitData?.plansMissingZipFile?.join(', ');
      },
      (error) => {
        window.scroll(0, 0);
        this.errorMessage = { message: error, details: [] };
      })
    );
  }

  cleanUpKits(): void {
    this.subscriptions.push(
      this.kitProcessingService.cleanUpKits(this.planIDCleanUp).subscribe((data) => {
        this.planIDCleanUp = '';
        this.successMessage = { message: 'Plans have been cleaned up in processing.', details: []};
        this.errorMessage = { message: '', details: [] };
      },
      (error) => {
        window.scroll(0, 0);
        this.errorMessage = { message: error, details: [] };
        this.successMessage = { message: '', details: [] };
      })
    );
  }

  submitKits(): void {
    this.subscriptions.push(
      this.kitProcessingService.flagEnrollment(this.planIdForEnrollment).subscribe((data) => {
        this.planIdForEnrollment = '';
        this.successMessage = { message: 'Plans have been submitted for processing.', details: []};
        this.errorMessage = { message: '', details: [] };
      },
      (error) => {
        window.scroll(0, 0);
        this.errorMessage = { message: error, details: [] };
        this.successMessage = { message: '', details: [] };
      })
    );
  }

  validateValue(event): void{
    const elem = event.target;
    const value = elem.value;
    const numVal = value.replace(/[^\d\n\,]+/g, "");
    elem.value = numVal;
  }
}
